export const HiringTypeMap = {
  '/m/beidou': '2_2-3,1_1-3',
  '/m/qihang': '1,2',
  '/m/trainee': '2_2-7,1_1-7',
  '/m/social': '3_',
  '/m/campus': '1,2',
  '/m/share/position': '',
  '/m/position': '',
};
